import {
    ReachTypes,
    ReachState,
    SET_EDITING_REACH_ELEMENTS,
    SET_GENERAL_VALIDATION_ERRORS, SET_REACH_ELEMENTS_AND_ERRORS
} from "./types";


export function reachReducer(
    state: ReachState = {editingReachElements: [], generalValidationErrors: []},
    action: ReachTypes
): ReachState {
    switch (action.type) {
        case SET_EDITING_REACH_ELEMENTS:
            return {
                editingReachElements: action.payload,
                generalValidationErrors: state.generalValidationErrors
            };
        case SET_GENERAL_VALIDATION_ERRORS:
            return {
                editingReachElements: state.editingReachElements,
                generalValidationErrors: action.payload
            };
        case SET_REACH_ELEMENTS_AND_ERRORS:
            return {
                editingReachElements: action.payload.elements,
                generalValidationErrors: action.payload.errors
            };
        default:
            return state;
    }
}
